import React, { useState } from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import { Box, Button, Grid } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';
import { putDownloadType } from 'redux/actions/Movies';
import { useDispatch } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { blue } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
  saveBtn: {
    marginRight: 7,
    color: blue[400],
    borderColor: blue[400],
  },
  actionBtnRoot: {
    marginTop: 15,
  },
}));

const DownloadType = () => {
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const params = new URLSearchParams(location.search);

  const movie = {
    uid: params.get('ui'),
    product_type: params.get('type'),
  };

  const [bundle, setBundle] = useState(movie.product_type === 'item' ? false : true);

  const jumpToList = () => {
    history.push('/movie');
  };

  const handleTypeChange = () => {
    setBundle(!bundle);
  };

  const handleSubmit = () => {
    bundle === true ? (movie.product_type = 'bundle') : (movie.product_type = 'item');
    dispatch(putDownloadType(movie, jumpToList));
  };

  return (
    <FormGroup aria-label="position" row>
      <Grid component="label" container alignItems="center" spacing={1}>
        <Grid item>آیتم</Grid>
        <Grid item>
          <Switch checked={bundle} onChange={handleTypeChange} name="" />
        </Grid>
        <Grid item>باندل</Grid>
      </Grid>
      <Box className={classes.actionBtnRoot}>
        <Button className={classes.saveBtn} variant="outlined" onClick={handleSubmit}>
          ‌ذخیره
        </Button>
        <Button color="secondary" variant="outlined" onClick={() => history.push('/movie')}>
          لغو
        </Button>
      </Box>
    </FormGroup>
  );
};

export default DownloadType;
